import {AnimatePresence, motion} from "framer-motion"
import React, {ReactNode} from "react"

import styles from "../FeaturesGrid.module.scss"

type ZoomedCardProps = {
	activeIndex: number | null
	layoutId: string
	onClose: () => void
	children: ReactNode
}

const ZoomedCard = ({
	activeIndex,
	layoutId,
	onClose,
	children,
}: ZoomedCardProps) => {
	return (
		<AnimatePresence>
			{activeIndex !== null && (
				<motion.div
					key={activeIndex}
					className={styles.popup}
					transition={{duration: 0.3}}
					onClick={(e: any) => e.stopPropagation()}
				>
					<motion.div
						className={styles.expandedContainer}
						layoutId={layoutId}
						layout
					>
						<button className={styles.closeBtn} onClick={onClose}>
							✕
						</button>
						{children}
					</motion.div>
				</motion.div>
			)}
		</AnimatePresence>
	)
}

export default ZoomedCard
